import { render } from "./ActOrganizerInfoModal.vue?vue&type=template&id=4540a7c2&scoped=true"
import script from "./ActOrganizerInfoModal.vue?vue&type=script&lang=js"
export * from "./ActOrganizerInfoModal.vue?vue&type=script&lang=js"

import "./ActOrganizerInfoModal.vue?vue&type=style&index=0&id=4540a7c2&lang=css&scoped=true"

import exportComponent from "/var/www/mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4540a7c2"]])

export default __exports__